'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./loader.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function Loader(_ref) {
  var children = _ref.children,
      className = _ref.className,
      position = _ref.position,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ['children', 'className', 'position', 'theme']);

  var classes = (0, _classnames2.default)('loader', theme && 'loader--' + theme, 'loader--position-' + position, className);

  return _react2.default.createElement(
    'div',
    _extends({ className: classes, 'data-e2e': 'loader' }, props),
    _react2.default.createElement('div', { className: 'loader-spinner' }),
    children && _react2.default.createElement(
      'div',
      { className: 'loader-message' },
      children
    )
  );
}

Loader.propTypes = {
  className: _propTypes2.default.string,
  theme: _propTypes2.default.oneOf(['dark']),
  position: _propTypes2.default.oneOf(['absolute', 'fixed']),
  children: _propTypes2.default.node
};

Loader.defaultProps = {
  position: 'fixed'
};

exports.default = Loader;